import React from 'react';
import { grenzpaketModule, useGrenzpaketIntake } from './grenzpaketModule';
import { vintedFreigeschaltet, anzeigeAktiv as vintedAktiv, vt } from '../services/vinted';
import { dhlFreigeschaltet, dhlAktiv, dt } from '../services/dhlBridge';
import { dpdFreigeschaltet, dpdAktiv, dpdT } from '../services/dpd';
import { vintedStationSubmodule, dhlStationSubmodule, STATION_SUBMODULES } from '../services/stationAnbindung';

export const vintedModule = {
  id: 'vinted',
  testIdOpen: 'vinted-open',
  isAvailable: () => vintedFreigeschaltet(),
  isActive: () => vintedAktiv(),
  getMenuLabel: (lang = 'de') => `${vt(lang)('titel')} →`,
  matchesSearch: () => false,
  stationSubmodule: vintedStationSubmodule,
};

export const dhlModule = {
  id: 'dhl',
  testIdOpen: 'dhl-bridge-open',
  isAvailable: () => dhlFreigeschaltet(),
  isActive: () => dhlAktiv(),
  getMenuLabel: (lang = 'de') => `${dt(lang)('titel')} →`,
  matchesSearch: () => false,
  stationSubmodule: dhlStationSubmodule,
};

export const dpdModule = {
  id: 'dpd',
  testIdOpen: 'dpd-open',
  isAvailable: () => dpdFreigeschaltet(),
  isActive: () => dpdAktiv(),
  getMenuLabel: (lang = 'de') => `${dpdT(lang).titel} →`,
  matchesSearch: () => false,
  stationSubmodule: STATION_SUBMODULES.find((m) => m.id === 'dpd') || null,
};

/**
 * Zentrale Liste aller Sonderkunden-/Drittsystem-Integrationen.
 * Neue Spezialkunden klinken sich hier als eigenes Modul ein, ohne dass
 * Standard-Komponenten (NewPackageModal, SignatureModal, AddPackageWithAI)
 * die interne Logik kennen müssen.
 */
export const INTEGRATIONS = [grenzpaketModule, vintedModule, dhlModule, dpdModule];

/**
 * Einheitlicher Annahme-Hook für NewPackageModal.js:
 * Bündelt OCR-Vorverarbeitung, Auto-Save-Sperre, Vor-Speicher-Anreicherung und UI-Slot.
 */
export function useIntegrationIntake(params) {
  const gp = useGrenzpaketIntake(params);
  return {
    allowEmptyShelf: !!gp.allowEmptyShelf,
    isBlockingAutoSave: gp.isBlockingAutoSave,
    preprocessOcr: gp.preprocessOcr,
    applyBeforeSave: gp.applyBeforeSave,
    renderIntakeSlot: gp.renderSlot,
  };
}

/**
 * Einheitlicher Ausgabe-Slot für SignatureModal.js:
 * Rendert modul-spezifische Hinweise (z.B. Grenzpaket Barzahlungs-/Guthaben-Banner).
 */
export function IntegrationPickupSlot({ paket, colors, lang = 'de' }) {
  return (
    <>
      {INTEGRATIONS.map((mod) => {
        if (!mod.PickupSlot) return null;
        const Comp = mod.PickupSlot;
        return <Comp key={mod.id} paket={paket} colors={colors} lang={lang} />;
      })}
    </>
  );
}

/**
 * Prüft modul-spezifische Zusatzfelder bei der Paketsuche (z.B. Grenzpaket KD-Nr. in Notizen).
 */
export function matchIntegrationSearch(paket, searchLower) {
  if (!paket || !searchLower) return false;
  for (const mod of INTEGRATIONS) {
    if (typeof mod.matchesSearch === 'function' && mod.matchesSearch(paket, searchLower)) {
      return true;
    }
  }
  return false;
}

